const routes = [
  {//登陆
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue'),
  },
  {//注册
    path: '/register',
    name: 'register',
    component: () => import('../views/register/index.vue'),
  },
  {//首页
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home/index.vue'),
  },
  {//洗车详情
    path: '/',
    name: 'carWash',
    component: () => import('../views/carWash/index.vue'),
  },
  {//个人中心
    path: '/user',
    name: 'user',
    component: () => import('../views/User/index.vue'),
  },
  {//个人设置
    path: '/user/settings',
    name: 'settings',
    component: () => import('../views/User/settings/index.vue'),
  },
  {//我的地址
    path: '/user/address',
    name: 'address',
    component: () => import('../views/User/address/index.vue'),
  },
  // {//编辑地址
  //   path: '/user/address/add',
  //   name: 'add',
  //   component: () => import('../views/User/address/add/index.vue'),
  // },
  {//个人资料
    path: '/user/details',
    name: 'details',
    component: () => import('../views/User/detilas/index.vue'),
  },
  {//修改密码
    path: '/user/resetPassword',
    name: 'resetPassword',
    component: () => import('../views/User/resetPassword/index.vue'),
  },
  {//服务协议
    path: '/user/agreement',
    name: 'agreement',
    component: () => import('../views/User/agreement/index.vue'),
  },
  {//隐私政策
    path: '/user/policy',
    name: 'policy',
    component: () => import('../views/User/policy/index.vue'),
  },
  {//关于我们
    path: '/user/about',
    name: 'about',
    component: () => import('../views/User/about/index.vue'),
  },
];

export default routes
